'use client'

import React from 'react'
import LandingLayout from '@components/Landing/LandingLayout'
import { Content } from '@components/Landing/Common'
import Box from '@ui/Box'
import Title from '@components/Landing/Title'

const Contact = () => {
  return (
    <LandingLayout
      meta={
        <>
          <title>Contact us - Enhanci</title>
        </>
      }
    >
      <Content maxWidth={1200}>
        <Title>Contact us</Title>
        <Box fontSize={24}>
          if you have any questions, please contact us at{' '}
          <a href="mailto:inbox@enhanci.com">inbox@enhanci.com</a>
        </Box>
      </Content>
    </LandingLayout>
  )
}

export default Contact
